module.exports = { id: "filter", url: "/build/app/img/symbols.svg#filter", viewBox: "", toString: function() { return this.url; } };